<template>
	<div class="col-12 px-0">
		<div v-if="errors.length" id="grouped-errors">
			<div class="alert alert-danger">
				<h4>{{ title }}</h4>
				<ul v-cloak>
					<li v-for="(error, index) in errors" :key="index" v-html="error" />
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
import {isArray, isObject, isString, isUndefined, isUndefinedOrNull} from 'tupy-helperjs';

export default {
    name: 'GroupedErros',

    props: {
        title: {
            type: String,
            required: false,
            default: 'Whoops!'
        }
    },

    data() {
        return {
            errors: [],
        }
    },

    methods: {
        async set(error, scrollTop = true) {
            await this.clear()

            if (isUndefined(error)) {
                this.errors.push('Não foi possível atender o pedido');

                if (scrollTop) {
                    this.scrollTo()
                }

                return this.errors;
            }

            if (error.response && error.response.hasOwnProperty('data')) {
                const data = error.response.data;

                if (data.hasOwnProperty('errors') && isObject(data.errors)) {
                    await this.setErrorWithMarkHtml(data.errors)
                } else if (data.hasOwnProperty('message')) {
                    this.errors.push(data.message)
                } else if (isString(data)) {
                    this.errors.push(data)
                } else {
                    this.errors.push(error)
                }
            } else if (isObject(error)) {
                await this.setErrorWithMarkHtml(error)
            } else if (isArray(error)) {
                console.debug('is array?')
                this.errors = error;

                if (scrollTop) {
                    this.scrollTo()
                }

                return this.errors;
            } else {
                this.errors.push(error)
            }

            if (scrollTop) {
                this.scrollTo()
            }

            return this.errors;
        },
        async setErrorWithMarkHtml(errors) {
            let element;
            await Object.keys(errors).forEach(key => {
                let text;

                if (isArray(errors[key])) {
                    text = errors[key][0]
                } else if (isString(errors[key])) {
                    text = errors[key]
                } else {
                    text = "Inválido"
                }

                element = document.getElementById(key);

                if (!isUndefinedOrNull(element)) {
                    if (!element.classList.contains('parsley-error')) {
                        element.classList.add('parsley-error')
                    }

                    let helperText = document.createElement('small')
                    helperText.classList.add('text-danger')
                    helperText.setAttribute('data-validator', key)
                    helperText.innerText = text;
                    element.insertAdjacentElement('afterEnd', helperText)
                }

                this.errors.push(text)
            })
        },
        async clear() {
            this.errors = [];

            let elementsWithError = document.getElementsByClassName('parsley-error')

            if (!isUndefinedOrNull(elementsWithError) && elementsWithError.length > 0) {
                await elementsWithError.forEach(element => {
                    element.classList.remove('parsley-error');
                })
            }

            let elementsHelperText = document.querySelectorAll('[data-validator]')

            if (!isUndefinedOrNull(elementsHelperText)) {
                await elementsHelperText.forEach(element => {
                    element.remove()
                })
            }

            return Promise.resolve(true);
        },
        scrollTo() {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            })
        },
        setErrors(errors) {
            this.errors = errors;
            this.scrollTo()
        }
    }
};
</script>
